module.exports = __webpack_public_path__ + "static/media/report_5.c45d466a.jpg";